import {useLocation} from 'react-router-dom';

function ErrorComponent(props) {

    const location = useLocation();
    const emailId = location.state.emailId;
return(
    <div>
        <label>No one Incident is registered with {emailId} email id</label>
    </div>
);
}

export default ErrorComponent;